import { css } from 'styled-components';

// style
import colors from '../../style/colors';
import { actionColor } from '../../style/theme-helpers';

const variants = {
  action: css`
    background-color: ${actionColor};
  `,
  sun: css`
    background: ${colors.sun};
  `,
  positive: css`
    background: ${colors.positive};
  `,
};

export { variants };
